import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bannerImg',
})
export class BannerImagePipe implements PipeTransform {
  transform(imgUrl: string) {
    if (!imgUrl) {
      return '';
    }

    const formatDotIndex = imgUrl.lastIndexOf('.');
    const urlWithoutFormat = imgUrl.slice(0, formatDotIndex);
    const imgFormat = imgUrl.slice(formatDotIndex);
    const tabletImgUrl = `${urlWithoutFormat}_1306${imgFormat}`;

    return tabletImgUrl;
  }
}
